import React from 'react';
import { ProgramCard, ProgramData } from './ProgramCard';
const programs: ProgramData[] = [{
  name: 'Kids Martial Arts',
  description: 'Structured martial arts training for children that builds discipline, confidence, and physical skills through age-appropriate instruction and progressive curriculum.',
  image: 'https://cdn.magicpatterns.com/uploads/rpUYVX6BTHcZD8MvBJVyvv/kids.jpg'
}, {
  name: 'Teen & Adult Classes',
  description: 'Comprehensive martial arts training for teens and adults focused on self-defense, fitness, and personal development through disciplined practice and skill progression.',
  image: 'https://cdn.magicpatterns.com/uploads/34YrwX6Uh42ERRoswozkZD/Teen-and-Adults.jpg'
}, {
  name: 'Brazilian Jiu-Jitsu',
  description: 'Ground-based grappling martial art that develops technical skill, strategic thinking, and physical conditioning through systematic training and live practice.',
  image: 'https://cdn.magicpatterns.com/uploads/aPhpJAWqY3QBXFC8MurJd8/bjj.jpg'
}, {
  name: 'Competition Team',
  description: 'Advanced training program for dedicated students pursuing competitive excellence in martial arts tournaments and demonstrations.',
  image: 'https://cdn.magicpatterns.com/uploads/dKu77WG1JfW9jNjCFoWbEn/competition.jpg'
}];
export function ProgramsGrid() {
  return <section className="py-16 bg-white" data-id="element-767">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-768">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-769">
          {programs.map(program => <ProgramCard key={program.name} program={program} data-id="element-770" />)}
        </div>
      </div>
    </section>;
}